import React from "react";
import LoadingIndicator from "../../../Component/LoadingIndicator";
import cookies from "js-cookie";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import http from "../../../network/HTTPClient";
import { Button } from "devextreme-react/button";
import "./radiostyle.css";

class LeavePrint extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
        ...props,
        users: cookies.get("user"),
        leaveType:[]
        };
        this.testku = {
            nama: "",
            jabatan: "",
            dariTgl: "",
            sampaiTgl:"",
            dariJam:"",
            sampaiJam:"",
            jenis:"",
            keterangan:""
        };
    }

    componentDidMount() {
        http.post("/leave/getTypes")
        .then((response) => {
            this.setState({ leaveType:response.data });
        });
    }

    printPDF = () => {
        html2canvas(document.getElementById('printLeave'),{allowTaint:true,scale:5}).then((canvas) => {
            canvas.getContext('2d');
            var imgData = canvas.toDataURL();
            var pdf = new jsPDF('p', 'pt', 'a5');
            
            const imgProps= pdf.getImageProperties(imgData);
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
            pdf.addImage(imgData, 'PNG', 5, 15,pdfWidth,pdfHeight);
            pdf.save("Cuti/Ijin.pdf");
        });
    }

    render() {
        if(Object.keys(this.props.rowData).length === 1){
            this.testku = {
                nama: this.props.rowData.rowData.employee_name,
                jabatan: this.props.rowData.rowData.jabatan,
                dariTgl: this.props.rowData.rowData.start_date,
                sampaiTgl: this.props.rowData.rowData.end_date,
                dariJam: this.props.rowData.rowData.start_time,
                sampaiJam: this.props.rowData.rowData.end_time,
                jenis: this.props.rowData.rowData.type,
                keterangan: this.props.rowData.rowData.desc
            };
        }
        return (
            <div className="container">
                <Button 
                text="Print"
                onClick={ (e) => {
                    this.printPDF();
                }}/>
            {this.state.formLoad ? (
                <LoadingIndicator />
            ) : (
                    <div id="printLeave" className="row">
                        <div className="text-center">
                            <h1>FORMULIR IJIN</h1>
                            <br/>
                        </div>
                        <div className="col">
                            <div className="dx-field">
                                <div style={{color : "#000",fontSize : "18px"}}>
                                    <p style={{fontWeight: "bold"}}>
                                        Nama :  {this.testku.nama}
                                    </p>
                                </div>
                            </div>
                            <div className="dx-field">
                                <div style={{color : "#000",fontSize : "18px"}}>
                                    <p style={{fontWeight: "bold"}}>
                                        Jabatan :  {this.testku.jabatan}
                                    </p>
                                </div>
                            </div>
                            <p style={{color : "#000",fontSize : "18px"}}>
                                <p style={{fontWeight: "bold"}}>
                                    Dengan ini mengajukan permohonan ijin :
                                </p>
                            </p>
                            {this.state.leaveType.map((item, i) => {
                                if(this.testku.jenis === item.id){
                                    return (
                                        <>
                                            <input type="radio" id={item.id} value={item.id} key={i} checked/>
                                            <label for={item.id} className="radio-style" key={"label-"+i}>{item.name}</label><br/>
                                        </>
                                    )
                                }
                                return (
                                    <>
                                        <input type="radio" id={item.id} value={item.id} key={i} disabled/>
                                        <label for={item.id} className="radio-style" key={"label-"+i}>{item.name}</label><br/>
                                    </>
                                )
                            })}
                        </div>
                        <div className="col">
                            <div className="dx-field">
                                <div style={{color : "#000",fontSize : "18px"}}>
                                    <p style={{fontWeight: "bold"}}>
                                        Dari Tanggal :  {this.testku.dariTgl}
                                    </p>
                                </div>
                            </div>
                            <div className="dx-field">
                                <div style={{color : "#000",fontSize : "18px"}}>
                                    <p style={{fontWeight: "bold"}}>
                                        Sampai Tanggal :  {this.testku.sampaiTgl}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="dx-field">
                                <div style={{color : "#000",fontSize : "18px"}}>
                                    <p style={{fontWeight: "bold"}}>
                                        Dari Jam :  {this.testku.dariJam}
                                    </p>
                                </div>
                            </div>
                            <div className="dx-field">
                                <div style={{color : "#000",fontSize : "18px"}}>
                                    <p style={{fontWeight: "bold"}}>
                                        Sampai Jam :  {this.testku.sampaiJam}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="row pt-1">
                            <div className="dx-field">
                                <div style={{color : "#000",fontSize : "18px"}}>
                                    <p style={{fontWeight: "bold"}}>
                                        Keterangan :  {this.testku.keterangan}
                                    </p>
                                </div>
                            </div>
                            <p className="pt-1" style={{color : "#000",fontSize : "18px"}}><b>Surabaya,</b></p>
                            <div className="col" style={{color : "#000",fontSize : "18px"}}>
                                <p style={{fontWeight: "bold"}}>Pemohon,</p>
                                <p className="pt-5" style={{fontWeight: "bold"}}>Karyawan</p>
                            </div>
                            <div className="col" style={{color : "#000",fontSize : "18px"}}>
                                <p style={{fontWeight: "bold"}}>Menyetujui,</p>
                                <p className="pt-5" style={{fontWeight: "bold"}}>Atasan</p>
                            </div>
                            <div className="col" style={{color : "#000",fontSize : "18px"}}>
                                <p style={{fontWeight: "bold"}}>Serah terima tugas,</p>
                                <p className="pt-5" style={{fontWeight: "bold"}}>Penerima</p>
                            </div>
                            <div className="col" style={{color : "#000",fontSize : "18px"}}>
                                <p style={{fontWeight: "bold"}}>Mengetahui,</p>
                                <p className="pt-5" style={{fontWeight: "bold"}}>HRD</p>
                            </div>
                        </div>
                    </div>
            )}
            </div>
        );
    }
}
export default LeavePrint;
